import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamMSMY() {
  return (
    <div className={styles["declaration"]}>
      <h1>Penyata Pematuhan untuk Latihan dan Peperiksaan Anggota "Field Force"</h1>

      <p>
        Untuk meningkatkan kualiti perkhidmatan juruhebah pihak ketiga di barisan hadapan secara berterusan, Pasukan Latihan Jabatan Antarabangsa Xiaomi (seterusnya dirujuk sebagai "kami" atau "syarikat kami") menyediakan kursus latihan dan peperiksaan pengukuhan pengetahuan untuk juruhebah pihak ketiga (seterusnya dirujuk sebagai "peserta latihan") yang ditetapkan oleh pembekal perkhidmatan outsourcing. Tujuan latihan dan peperiksaan ini adalah untuk mengoptimumkan kandungan kursus dan mengukuhkan hasil pembelajaran, serta tidak membentuk sebarang bentuk hubungan pekerjaan atau tingkah laku pengurusan sebenar. Berikut adalah kandungan berkenaan latihan dan peperiksaan:
      </p>

      <ol>
        <li>
          <strong>Jenis latihan dan peperiksaan</strong><br/>
          Semua kursus latihan dan peperiksaan dijalankan untuk tujuan perkongsian pengetahuan, bertujuan untuk membantu peserta latihan memahami maklumat produk dan piawaian perkhidmatan dan lain-lain secara sistematik. Keputusan peperiksaan hanya mencerminkan kefahaman peserta latihan terhadap kandungan latihan dan tidak boleh dijadikan asas untuk penilaian prestasi; kami tidak mempunyai kuasa dan tidak akan campur tangan dalam penilaian prestasi, pengagihan gaji, atau perkara lain yang berkaitan dengan hubungan pekerjaan antara penyedia perkhidmatan outsourcing dengan peserta latihan.
        </li>
        <li>
          <strong>Pensabitan hubungan undang-undang</strong><br/>
          Hubungan majikan-pekerja antara peserta latihan dan pembekal perkhidmatan outsourcing masing-masing kekal tidak terjejas oleh program latihan dan peperiksaan ini. Tiada hubungan majikan-pekerja antara syarikat kami dengan para peserta latihan, dan program latihan serta peperiksaan perkongsian pengetahuan ini juga tidak mewujudkan sebarang hubungan pekerjaan secara de facto dengan para peserta latihan.
        </li>
        <li>
          <strong>Penggunaan keputusan peperiksaan</strong><br/>
          Keputusan peperiksaan hanya akan digunakan untuk tujuan berikut:
          <ol type="1">
            <li>Berfungsi sebagai rujukan untuk pengoptimuman dan penambahbaikan kursus dalaman syarikat kami;</li>
            <li>Disediakan kepada pembekal perkhidmatan outsourcing sebagai bukti kecekapan profesional peserta latihan, tertakluk kepada pertimbangan bebas dan kesediaan pembekal perkhidmatan outsourcing;</li>
            <li>Keputusan peperiksaan tidak akan diumumkan atau didedahkan kepada mana-mana pihak ketiga.</li>
          </ol>
        </li>
      </ol>

      <p>
        Penyata ini akan berkuat kuasa dari tarikh penerbitan. Penyertaan dalam program latihan dan peperiksaan membentuk pengakuan dan penerimaan peserta latihan terhadap penyata ini. Syarikat kami berhak untuk membuat pentafsiran dan pindaan yang munasabah berkenaan dengan penyata ini.
      </p>

      <div className={styles["footer"]}>
        Pasukan Latihan Jabatan Antarabangsa Xiaomi<br/>
        Tarikh: {getLocalizedTime('ms-MY')}
      </div>
    </div>
  );
}